import { reconcile } from "solid-js/store";

import { getUserPointV2 } from "@/api/clientApi/user";
import { getUserInfo, setUserStore, userStore } from "@/stores/userStore";
import { GetUserPointV2Rsp } from "@/types/swagger/appserver";
import { UserPoint } from "@/types/swagger/front";

export function useUser() {
  // 更新用户信息
  const updateUserInfo = async () => {
    await getUserInfo();
  };
  // 更新用户货币
  const updateUserPoint = async () => {
    await getUserPointV2().then((res: GetUserPointV2Rsp | undefined) => {
      if (res) {
        setUserStore(
          "userInfo",
          reconcile({
            ...userStore.userInfo,
            is_pay: res.is_pay,
            crypto_user_points:
              res.crypto_user_points as unknown as UserPoint[],
          }),
        );
      }
    });
  };

  return { updateUserInfo, updateUserPoint };
}
